
import Vue from 'vue'

const axios = require("axios")
import config from '@/config'


function resetState(state) {
   Object.assign(state, {
      surveys: {},
      surveyList: [],
      userSurveys: {},
      userSurveyAnswers: {},
      user2userSurveyList: {},
   })
}

const state = {}
resetState(state)

const mutations = {

   RESET_STATE (state) {
      //console.log('surveys/RESET_STATE')
      resetState(state)
   },

   SET_SURVEYS (state, surveys) {
      surveys.forEach(survey => {
         state.surveys[survey.id] = survey
      })
      state.surveyList = surveys.map(survey => survey.id)
   },

   SET_USER_SURVEYS (state, { userId, userSurveys }) {
      userSurveys.forEach(userSurvey => {
         Vue.set(state.userSurveys, userSurvey.id, userSurvey)
         Vue.set(state.userSurveyAnswers, userSurvey.id, userSurvey.answers.join(','))
      })
      Vue.set(state.user2userSurveyList, userId, userSurveys.map(userSurvey => userSurvey.id))
   },

   ADD_USER_SURVEY (state, userSurvey) {
      // add userSurvey to state.userSurveys
      Vue.set(state.userSurveys, userSurvey.id, userSurvey)
      Vue.set(state.userSurveyAnswers, userSurvey.id, userSurvey.answers.join(','))
      // add userSurvey to state.user2userSurveyList
      if (!state.user2userSurveyList.hasOwnProperty(userSurvey.user)) state.user2userSurveyList[userSurvey.user] = []
      state.user2userSurveyList[userSurvey.user].push(userSurvey.id)
   },

   REMOVE_USER_SURVEY (state, userSurvey) {
      let index = state.user2userSurveyList[userSurvey.user].indexOf(userSurvey.id)
      Vue.delete(state.user2userSurveyList[userSurvey.user], index)
      Vue.delete(state.userSurveys, userSurvey.id)
   },

   SET_USER_SURVEY (state, userSurvey) {
      Vue.set(state.userSurveys, userSurvey.id, userSurvey)
      Vue.set(state.userSurveyAnswers, userSurvey.id, userSurvey.answers.join(','))
      Vue.set(state.userSurveys[userSurvey.id], 'answers', userSurvey.answers)
   },
}

const actions = {

   GET_SURVEYS ({ commit, rootState }) {
      return axios({
         method: 'get',
         url: config.SURVEYS_URL,
         headers: {"Authorization": `JWT ${rootState.authenticationData.token}`},
      })
      .then(function(response) {
         commit('SET_SURVEYS', response.data)
         return response.data
      })
   },

   GET_USER_SURVEYS ({ commit, rootState }, userId) {
      return axios({
         method: 'get',
         url: `${config.USER_SURVEYS_URL}?user=${userId}`,
         headers: {"Authorization": `JWT ${rootState.authenticationData.token}`},
      })
      .then(function(response) {
         let userSurveysDict = { userId: userId, userSurveys: response.data }
         commit('SET_USER_SURVEYS', userSurveysDict)
         return response.data
      })
   },

   POST_USER_SURVEY ({ commit, rootState }, { userId, surveyId }) {
      return axios({
         method: 'post',
         url: config.USER_SURVEYS_URL,
         headers: {"Authorization": `JWT ${rootState.authenticationData.token}`},
         data: { user: userId, survey: surveyId },
      })
      .then(function(response) {
         commit('ADD_USER_SURVEY', response.data)
         return response.data
      })
   },

   DELETE_USER_SURVEY ({ commit, rootState }, userSurvey) {
      return axios({
         method: 'delete',
         url: `${config.USER_SURVEYS_URL}${userSurvey.id}/`,
         headers: {"Authorization": `JWT ${rootState.authenticationData.token}`},
      })
      .then(function(response) {
         commit('REMOVE_USER_SURVEY', userSurvey)
         return userSurvey
      })
   },

   PUT_USER_SURVEY ({ commit, rootState }, userSurvey) {
      return axios({
         method: 'put',
         url: `${config.USER_SURVEYS_URL}${userSurvey.id}/`,
         headers: {"Authorization": `JWT ${rootState.authenticationData.token}`},
         data: userSurvey,
      })
      .then(function(response) {
         commit('SET_USER_SURVEY', userSurvey)
         return userSurvey
      })
   },
}

const getters = {

   // returns a function giving the surveys of a user
   userSurveys: (state) => (userId) => {
      return state.user2userSurveyList.hasOwnProperty(userId) ? state.user2userSurveyList[userId].map(userSurveyId => state.userSurveys[userSurveyId]) : []
   },
}

export default {
   namespaced: true,
   state,
   mutations,
   actions,
   getters,
}



// WEBPACK FOOTER //
// ./src/store/surveys/index.js